export const arraysAreEqual = (arr1: string[] = [], arr2: string[] = []) =>
  arr1.length === arr2.length && arr1.every((item, index) => item === arr2[index]);
